import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PARTNERS } from "@/data/partners";

export const PartnersGrid = () => (
  <div className="mt-10 grid gap-5 sm:grid-cols-2" data-testid="partners-grid">
    {PARTNERS.map((p, i) => (
      <motion.article
        key={p.id}
        data-testid={`partner-card-${p.id}`}
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.55, delay: i * 0.08 }}
        className="group flex flex-col rounded-2xl border border-[#E8E2E4] bg-white p-7 shadow-[0_8px_32px_rgba(94,42,82,0.05)] transition-transform duration-300 hover:-translate-y-1 sm:p-8"
      >
        <div className="flex items-start justify-between gap-4">
          <img
            src={p.logo}
            alt={`Logo ${p.nome}`}
            data-testid={`partner-logo-${p.id}`}
            loading="lazy"
            className={
              p.logoDark
                ? "h-16 w-16 rounded-xl bg-[#0E1116] object-contain p-2.5"
                : "h-20 w-auto max-w-[190px] object-contain object-left mix-blend-multiply"
            }
          />
          <span className="rounded-full bg-[#E0708A]/12 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-[#5E2A52]">
            {p.tier}
          </span>
        </div>

        <h3 className="mt-6 font-display text-2xl text-[#1A1617]">{p.nome}</h3>
        <p className="mt-1 text-sm text-[#6B5E62]">{p.settore}</p>
        <p className="mt-4 flex-1 text-sm leading-relaxed text-[#6B5E62]">
          {p.descrizione}
        </p>

        {p.sito ? (
          <a
            href={p.sito}
            target="_blank"
            rel="noreferrer"
            data-testid={`partner-link-${p.id}`}
            className="mt-6 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.16em] text-[#5E2A52] transition-colors duration-300 hover:text-[#E0708A]"
          >
            Visita il sito
            <ArrowUpRight
              size={13}
              className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
            />
          </a>
        ) : (
          <span className="mt-6 text-xs uppercase tracking-[0.16em] text-[#6B5E62]/70">
            Sito in arrivo
          </span>
        )}
      </motion.article>
    ))}
  </div>
);
